import type AppRouter from '@omniwound/api';
import { type TRPCLink } from '@trpc/client';
import { observable } from '@trpc/server/observable';

import { apiErrorCode, apiErrorStatus } from './api-error';

function isUnauthorized(error: unknown): boolean {
  return (
    apiErrorStatus(error) === 401 || apiErrorCode(error) === 'UNAUTHORIZED'
  );
}

type AuthRecoveryCallbacks = {
  onUnauthorized: (error: unknown) => Promise<void>;
  onBffSuccess: () => void;
};

export function authRecoveryLink({
  onUnauthorized,
  onBffSuccess,
}: AuthRecoveryCallbacks): TRPCLink<AppRouter> {
  return () =>
    ({ op, next }) =>
      observable((observer) => {
        const subscription = next(op).subscribe({
          next: (value) => {
            onBffSuccess();
            observer.next(value);
          },
          error: (error) => {
            if (isUnauthorized(error)) {
              void onUnauthorized(error).catch(() => undefined);
            }
            observer.error(error);
          },
          complete: () => observer.complete(),
        });

        return () => subscription.unsubscribe();
      });
}
